// index.js
import en from './en.json'
import de from './de.json'

export const defaultLocale = 'de'

export const languages = {
  en: en,
  de: de,
}